<template>
    <svg t="1564191959447" class="icon" viewBox="0 0 1024 1024">
        <path d="M739.9561637 732.94012189c-12.24489074-3.33919801-25.09637973-5.13104782-38.39961543-5.13104783-53.85679645 0-100.91993088 29.11552626-126.34464142 72.52859563-8.21759431 13.96804722-22.45343005 23.49663801-38.64295311 24.55498297-6.79249693 0.44825373-13.62690958 0.65316978-20.50207175 0.65316977-159.04852537 0-290.67906731-117.20143303-313.66225124-269.99420131-2.92820195-19.62768611 6.34540829-38.97128391 23.2684362-49.23338069 42.38383331-25.65640533 70.73674581-72.24334336 70.73674582-125.46909184 0-28.71035221-8.25718101-55.46468807-22.49534464-78.06598372-25.95213653-41.1706368-71.75317504-68.53739293-123.94153643-68.53739292-78.26391381 0-142.16624697 61.45149269-146.23429405 138.78397042-0.12225081 2.60569202-0.20375211 5.21254912-0.2037521 7.81940508 0 7.45265266 0.5681755 14.74113991 1.6276844 21.86778965 23.75627662 345.45216398 311.13805938 618.29772288 662.22191844 618.29772288 7.77166962 0 15.53868231-0.16300146 23.22885063-0.44825372 3.6209573 0.28525227 7.2395867 0.44825373 10.9420453 0.44825372 10.33079011 0 20.37865586-1.05834382 30.05976917-3.09469639 66.46727566-13.88654706 116.37594795-72.85343459 116.37594795-143.50751516C847.99459442 806.77272803 802.19355591 749.84102912 739.9561637 732.94012189L739.9561637 732.94012189z"  :fill="color" p-id="16872"></path>
        <g>
            <path class="l1" d="M686.91786752 621.87685319c-22.45692302 0-40.67697664-18.21888853-40.67697664-40.67697664 0-112.28461511-91.23299555-203.65034041-203.38488093-203.65034041-22.45692302 0-40.67697664-18.21888853-40.67697664-40.67697664 0-22.45692302 18.22005362-40.67697664 40.67697664-40.67697664 157.01683086 0 284.73883421 127.85822493 284.73883421 285.00429255C727.59484302 603.65796352 709.37595449 621.87685319 686.91786752 621.87685319L686.91786752 621.87685319z" :fill="color"></path>
            <path class="l2" d="M833.33961273 597.46042083c-22.45808697 0-40.67697664-18.21888853-40.67697664-40.67697664 0-179.65654813-145.96999965-325.83961373-325.41697479-325.83961372-22.45808697 0-40.67697664-18.21888853-40.67697664-40.67697664s18.21888853-40.67697664 40.67697664-40.67697664c224.30726371 0 406.77092693 182.67672917 406.77092693 407.19356587C874.01658937 579.2415323 855.7976997 597.46042083 833.33961273 597.46042083L833.33961273 597.46042083z" :fill="color"></path>
            <path class="l3" d="M979.78813781 573.01837483c-22.45808697 0-40.67697664-18.22005362-40.67697664-40.67697664 0-247.02848114-200.73843826-448.00327225-447.44790243-448.00327225-22.45808697 0-40.67697664-18.21888853-40.67697664-40.67697664 0-22.45808697 18.21888853-40.67697664 40.67697664-40.67697664 291.57091669 0 528.80185571 237.46845469 528.80185571 529.35722439C1020.46511331 554.79832235 1002.24622478 573.01837483 979.78813781 573.01837483L979.78813781 573.01837483z" :fill="color"></path>
        </g>
    </svg>
</template>

<script>
    export default {
        props:{
            size: {
                type: String,
                default: '120px'
            },
            color: {
                type: String,
                default: '#585858'
            }
        }
    }
</script>

<style lang="less" scoped>
@keyframes fade
{
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0.3;
    }
    100% {
        opacity: 0.3;
    }
}

.l1{
    animation: fade 1s infinite;
    animation-delay: .1s;
}
.l2{
    animation: fade 1s infinite;
    animation-delay: .4s;
}
.l3{
    animation: fade 1s infinite;
    animation-delay: .7s;
}
</style>
